import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { SMART_BANNER_FEATURE, SmartBannerState, StateWithSmartBanner } from '../smart-banner-state';

export const getFeatureState: MemoizedSelector<StateWithSmartBanner, SmartBannerState> =
  createFeatureSelector<SmartBannerState>(SMART_BANNER_FEATURE);
